import React, { useEffect, useState, useContext } from 'react';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import { Context } from '../../../context/UserContext';
import styles from '../../form/Form.module.css';

import Form from './Form';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { getEmpresaScope } from '../../../helpers/sessionEmpresa';
import { resolveEmpresaTabela } from '../../../utils/funcoes';

//utils
import * as TabelaAPI from '../../../api/tabela';
import * as VerificadoresAPI from '../../../api/verificadores';
import * as EmpresaAPI from '../../../api/empresa';
import * as DataListAPI from '../../../api/dataList';

import * as PessoaAPI from '../../../api/pessoa';

import { buildFormData } from '../../../utils/FormDataBuilder';
import { obterCnhCategorias } from '../../../api/cnh';

const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');

const CreateOrEdit = () => {
    const [dados, setDados] = useState({});
    const [token] = useState(localStorage.getItem('token')) || '';
    const { parametro } = useContext(Context);
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    const urlParams = new URLSearchParams(window.location.search);

    // escopo empresa
    const { pessoaId, empresaId, empresaIds } = getEmpresaScope();
    const empresaTabelaId = resolveEmpresaTabela(parametro, empresaId);

    const pathname = '/Pessoa';
    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText');
    const consultaPessoa = urlParams.get('consultaPessoa');
    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
        consultaPessoa: consultaPessoa,
    });

    //enums e tabelas
    //pessoa
    const [optionsEmpresa, setEmpresa] = useState([]);
    const [optionsCnhCategoria, setCnhCategoria] = useState([]);
    const [EnumTipo, setEnumTipo] = useState([]);
    const [EnumVinculoFinanceiro, setEnumVinculoFinanceiro] = useState([]);

    //pessoaNome
    const [EnumOrigem, setEnumOrigem] = useState([]);

    //pessoaFisica
    const [EnumSexo, setEnumSexo] = useState([]);
    const [EnumEstadoCivil, setEnumEstadoCivil] = useState([]);
    const [EnumTipoSanguineo, setEnumTipoSanguineo] = useState([]);
    const [EnumCnhCategoria, setEnumCnhCategoria] = useState([]);
    const [optionsPais, setPais] = useState([]);

    //pessoaJuridica
    const [EnumRamoAtividade, setEnumRamoAtividade] = useState([]);
    const [EnumPJTipo, setEnumPJTipo] = useState([]);

    //endereços
    const [ufs, setUfs] = useState([]);
    const [municipios, setMUNICIPIO] = useState([]);
    const [EnumTipoEndereco, setEnumTipoEndereco] = useState([]);

    //contatos
    const [EnumTipoEmail, setEnumTipoEmail] = useState([]);
    const [EnumTipoTelefone, setEnumTipoTelefone] = useState([]);

    //const [pessoaEmpresa, setDadosEmpresa] = useState([]);

    //carregar ENUMS
    const consultaEnum = async (table, field, filter) => {
        const result = await TabelaAPI.enums(table, field, filter);
        if (table === 'Pessoas') {
            field === 'tipo' && setEnumTipo(result ? result : []);
            field === 'vinculoFinanceiro' && setEnumVinculoFinanceiro(result ? result : []);
        } else if (table === 'pessoaNomes') {
            field === 'origem' && setEnumOrigem(result ? result : []);
        } else if (table === 'pessoaFisicas') {
            field === 'sexo' && setEnumSexo(result ? result : []);
            field === 'estadoCivil' && setEnumEstadoCivil(result ? result : []);
            field === 'tipoSanguineo' && setEnumTipoSanguineo(result ? result : []);
            field === 'cnhCategoria' && setEnumCnhCategoria(result ? result : []);
        } else if (table === 'pessoaJuridicas') {
            field === 'ramoAtividade' && setEnumRamoAtividade(result ? result : []);
            field === 'tipo' && setEnumPJTipo(result ? result : []);
        } else if (table === 'pessoaEnderecos') {
            field === 'tipo' && setEnumTipoEndereco(result ? result : []);
        } else if (table === 'pessoaEmails') {
            field === 'tipo' && setEnumTipoEmail(result ? result : []);
        } else if (table === 'pessoaTelefones') {
            field === 'tipo' && setEnumTipoTelefone(result ? result : []);
        }
    };

    // params => empresaId, tabela, id, descricao, condicao, filtro, operacao, funcionarioId
    const consultaDatalist = async (params) => {
        try {
            return await DataListAPI.dataList(params);
        } catch (error) {
            console.error('Erro ao consultar DataList:', error);
            throw error;
        }
    };
    //carregar API's Externas
    const consultaEmpresa = async () => {
        const result = await EmpresaAPI.empresa(dados.empresaId);
        setEmpresa(result);
    };

    const consultaUF = async () => {
        const uf = await VerificadoresAPI.uf('');
        setUfs(uf);
    };
    const consultaMUNICIPIO = async (ufId, uf, descricao) => {
        const municipio = await VerificadoresAPI.municipio(ufId, uf, descricao);
        setMUNICIPIO(municipio);
    };
    const consultaPais = async () => {
        const result = await TabelaAPI.retornaPais();
        setPais(result);
    };
    const consultaCnhCategoria = async () => {
        const data = await obterCnhCategorias();
        const result = (data || []).map((item) => ({
            id: item.id,
            descricao: item.sigla, // muda descricao para valor da sigla
            titulo: item.descricao, // title recebe descricao original
        }));
        setCnhCategoria(result);
    };

    //funções e rotinas acionadas pelo useEffect
    useEffect(() => {
        if (!token) {
            return navigate('/Auth', { replace: true });
        }

        if (uuid && uuid !== 'null') {
            PessoaAPI.consulta(uuid)
                .then((response) => {
                    setDados(response.data);
                })
                .catch((error) => {
                    console.error(error);
                    setFlashMessage(error.response.data.message, error.response.data.type);
                });
        }

        //carregar ENUMS
        //pessoa
        consultaEnum('Pessoas', 'tipo');
        consultaEnum('Pessoas', 'vinculoFinanceiro');
        //pessoaNome
        consultaEnum('pessoaNomes', 'origem');
        //pessoaFisica
        consultaEnum('pessoaFisicas', 'sexo');
        consultaEnum('pessoaFisicas', 'estadoCivil');
        consultaEnum('pessoaFisicas', 'tipoSanguineo');
        consultaEnum('pessoaFisicas', 'cnhCategoria');
        consultaPais();
        //pessoaJuridica
        consultaEnum('pessoaJuridicas', 'ramoAtividade');
        consultaEnum('pessoaJuridicas', 'tipo');
        //Endereco
        consultaEnum('pessoaEnderecos', 'tipo');
        //email
        consultaEnum('pessoaEmails', 'tipo');
        //telefones
        consultaEnum('pessoaTelefones', 'tipo');

        //carregar API's Externas
        consultaEmpresa();

        consultaUF();
        consultaMUNICIPIO();
        //categoria da cnh
        consultaCnhCategoria();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, uuid]);

    async function managerDados(obj) {
        let urlNavigate = pathname;

        if (!obj.CPForCNPJ.length) {
            obj.CPForCNPJ = onlyNumbers(obj.CPForCNPJ);
        }

        const formData = new FormData();
        buildFormData(obj, formData);

        try {
            let response;

            if (uuid && uuid !== 'null') {
                response = await PessoaAPI.editar(formData);
            } else {
                response = await PessoaAPI.cadastrar(formData);

                if (response.status === 202) {
                    setDados(response.data);
                    response.data.message = 'Registro em duplicidade!';
                    response.data.type = 'warning';
                    urlNavigate = pathname + '/CreateOrEdit';
                    params.set('uuid', response.data.uuid);
                    params.set('btnText', 'Atualizar');
                }
            }

            setFlashMessage(response.data.message, response.data.type);

            setTimeout(() => {
                navigate(urlNavigate, params);
            }, parametro.msgTempo * 1000);
        } catch (error) {
            console.error(error);
            setFlashMessage(error.message, 'error');
            setFlashMessage(error.response.data.message, error.response.data.type);
        }
    }

    const propsComuns = {
        token,
        handleSubmit: managerDados,
        formData: dados,
        parametro: { parametro },
        btnText,
        tipo, // importante
        EnumTipo,
        EnumVinculoFinanceiro,
        EnumOrigem,
        EnumSexo,
        EnumTipoSanguineo,
        EnumEstadoCivil,
        EnumCnhCategoria,
        EnumRamoAtividade,
        EnumPJTipo,
        EnumTipoEndereco,
        EnumTipoEmail,
        EnumTipoTelefone,
        ufs,
        municipios,
        optionsEmpresa,

        optionsPais,
        optionsCnhCategoria,
        params,
        caminhoVoltar: pathname,

        navigate,
        setFlashMessage,
        consultaDatalist,

        pessoaId,
        empresaId,
        empresaIds,
        empresaTabelaId,
    };

    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <Form {...propsComuns} />
        </section>
    );
};
export default CreateOrEdit;
